import { Api } from 'lib/api.mjs';

/** Weekly tests — the count the affiliate is paid on. */

/** @param {Object} payload The test to submit. */
export function createTest(payload) {
  return Api.post('/tests', { body: payload });
}

/** @param {{ campaignId: string }} payload */
export function removeTest({ campaignId }) {
  return Api.delete(`/tests/${campaignId}`);
}

/** @param {{ campaignId: string, text: string }} payload */
export function commentOnTest({ campaignId, text }) {
  return Api.post(`/tests/${campaignId}/comment`, { body: { text } });
}
